import type { OmsNavIconName } from '@/shared/ui/Icon'

export interface OmsNavItem {
  k: string
  ko: string
  en: string
  zhTW: string
  path: string
  icon: OmsNavIconName
  mobile?: boolean
  action?: boolean
}

export type OmsLocale = 'ko' | 'en' | 'zh-TW'

export const OMS_NAV: OmsNavItem[] = [
  { k: 'home', ko: 'OMS 홈', en: 'OMS Home', zhTW: 'OMS 首頁', path: '/', icon: 'Home', mobile: true },
  { k: 'order', ko: '주문', en: 'Orders', zhTW: '訂購', path: '/order', icon: 'Clipboard' },
  { k: 'order-history', ko: '주문내역', en: 'Order History', zhTW: '訂單紀錄', path: '/order-history', icon: 'Clipboard', mobile: true },
  { k: 'cart', ko: '장바구니', en: 'Cart', zhTW: '購物車', path: '/cart', icon: 'Cart', mobile: true },
  { k: 'transfer-history', ko: '송금내역', en: 'Transfers', zhTW: '匯款紀錄', path: '/transfer-history', icon: 'Banknote' },
  { k: 'notice', ko: '공지사항', en: 'Notices', zhTW: '公告', path: '/notice', icon: 'Notice' },
  { k: 'notification', ko: '알림', en: 'Notifications', zhTW: '通知', path: '/notification', icon: 'Bell' },
  { k: 'settings', ko: '더보기', en: 'More', zhTW: '更多', path: '/settings', icon: 'Settings', mobile: true },
]

export const OMS_RAIL_NAV = OMS_NAV.filter((item) => item.k !== 'settings')

export const OMS_SETTINGS_NAV: OmsNavItem[] = [
  {
    k: 'language',
    ko: '언어',
    en: 'Language',
    zhTW: '語言',
    path: '/settings?action=language',
    icon: 'Language',
    action: true,
  },
  {
    k: 'notification-settings',
    ko: '알림 설정',
    en: 'Notification Settings',
    zhTW: '通知設定',
    path: '/settings/notification',
    icon: 'BellSettings',
  },
  {
    k: 'change-password',
    ko: '비밀번호 변경',
    en: 'Change Password',
    zhTW: '變更密碼',
    path: '/change-password',
    icon: 'Key',
  },
]

export const OMS_MOBILE_NAV = OMS_NAV.filter((item) => item.mobile)

export function omsLabel(item: OmsNavItem, locale: OmsLocale) {
  if (locale === 'en') return item.en
  if (locale === 'zh-TW') return item.zhTW
  return item.ko
}

export function omsTitleForPath(path: string, locale: OmsLocale = 'ko') {
  const items = [...OMS_SETTINGS_NAV, ...OMS_NAV]
  const normalizedPath = path.split('?')[0]
  const item = items.find((entry) => {
    if (entry.path.includes('?')) {
      return path === entry.path || path.startsWith(`${entry.path}&`)
    }
    if (entry.path === '/') return normalizedPath === '/' || normalizedPath === ''
    return normalizedPath === entry.path || normalizedPath.startsWith(`${entry.path}/`)
  })
  return item ? omsLabel(item, locale) : undefined
}

export function isOmsPathActive(activePath: string, itemPath: string) {
  if (itemPath === '/') return activePath === '/' || activePath === ''
  const normalizedItemPath = itemPath.split('?')[0]
  return activePath === normalizedItemPath || activePath.startsWith(`${normalizedItemPath}/`)
}
